import React from 'react'
import PropTypes from 'prop-types'
import {
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
} from '@mui/material'
import { withStyles } from 'tss-react/mui'
import { ClearIcon } from 'icons'

import styles from './EditTextField.style'

class EditTextField extends React.PureComponent {
  createAdornment =() => {
    const {
      resetField,
      classes,
    } = this.props
    return (
      <InputAdornment position="start">
        <IconButton onClick={resetField} aria-label="Delete" size="large">
          <ClearIcon className={classes.icon} />
        </IconButton>
      </InputAdornment>
    )
  }

  createTextField =() => {
    const {
      input,
      disabled,
      title,
    } = this.props
    return (
      <TextField
        disabled={disabled}
        onChange={(event, index, value) => input.onChange(value)}
        InputProps={{
          endAdornment: this.createAdornment(),
          ...input,
        }}
        variant="outlined"
        label={title}
      />
    )
  }

  render() {
    const {
      meta: { touched, error },
      classes,
      hint,
    } = this.props
    return (
      <FormControl variant="standard" className={classes.input}>
        { hint
          ? <Tooltip title={hint} placement="bottom">{this.createTextField()}</Tooltip>
          : this.createTextField() }
        {touched && error && (
          <FormHelperText id="component-error-text" className={classes.text}>
            {error}
          </FormHelperText>
        )}
      </FormControl>
    )
  }
}

EditTextField.propTypes = {
  classes: PropTypes.object.isRequired,
  input: PropTypes.object.isRequired,
  meta: PropTypes.shape({
    error: PropTypes.string,
    touched: PropTypes.bool,
  }).isRequired,
  resetField: PropTypes.func.isRequired,
  hint: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
}

EditTextField.defaultProps = {
  disabled: false,
}

export default (withStyles(EditTextField, styles))
